import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { getImage } from "gatsby-plugin-image"
import loadable from '@loadable/component'
import pMinDelay from 'p-min-delay'
import { Menu, Transition } from '@headlessui/react'
import styled from 'styled-components';

import UpdateLogoVersion from '../common/UpdateLogoVersion'
import TwitterIcon from '../../assets/twitter.svg'
import LinkedinIcon from '../../assets/linkedin.svg'
import YoutubeIcon from '../../assets/youtube.svg'

const StyledDiv = styled.div`
  background: #981d22;
  width: 100%;
  height: 300px;
`;

const AddEventWidgetsNew = loadable(
  () => pMinDelay(import('./AddEventWidgetsNew'), 5000),
  {
    fallback: (
      <div className='lg:absolute lg:top-0 lg:right-0 w-11/12 lg:w-9/12 lg:max-w-screen-lg mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 mt-6 lg:mt-16 mb-6'>
        <div className='w-full' aria-label='Command Access Upcoming Trainings'>
          <StyledDiv className='flex flex-col items-center justify-center'>
            <div><p className='text-white font-body text-lg normal-case italic'>Loading events...</p></div>
          </StyledDiv>
        </div>
        <div className='w-full' aria-label='Command Access Upcoming Trade Shows'>
          <StyledDiv className='flex flex-col items-center justify-center'>
            <div><p className='text-white font-body text-lg normal-case italic'>Loading events...</p></div>
          </StyledDiv>
        </div>
      </div>
    ),
  }
);

const TitleNew = 'font-body text-xl text-blue-200 font-semibold'
const MenuLinkNew = 'text-white text-sm mb-3 text-gray-100 text-center hover:underline'

const FooterNavNewUpdateVersionNew = () => {
  const data = useStaticQuery(graphql`
    query FooterNavNewUpdateVersionNewQuery {
      prismicNavigation {
        data {
          footer_logo {
            gatsbyImageData(
              width: 300
            )
          }
          address
          google_maps_link
          phone_number
          email_address
          hours
          twitter_link
          linkedin_link
          youtube_link
          first_product_category_name
          first_product_category_description
          second_product_category_name
          second_product_category_description
          third_product_category_name
          third_product_category_description
          fourth_product_category_name
          fourth_product_category_description
          fifth_product_category_name
          fifth_product_category_description
          sixth_product_category_name
          sixth_product_category_description
          seventh_product_category_name
          seventh_product_category_description
          eight_product_category_name
          eight_product_category_description
          ninth_product_category_name
          ninth_product_category_description
          tenth_product_category_name
          tenth_product_category_description
          first_resource_name
          first_resource_description
          second_resource_name
          second_resource_description
          third_resource_name
          third_resource_description
          fourth_resource_name
          fourth_resource_description
          fifth_resource_name
          fifth_resource_description
          first_menu_name
          first_menu_description
          second_menu_name
          second_menu_description
        }
      }
    }
  `)

  const nav = data.prismicNavigation.data
  const logo = getImage(nav.footer_logo)

  const products = [
    { name: nav.first_product_category_name, link: '/command-packages', desc: nav.first_product_category_description },
    { name: nav.second_product_category_name, link: '/low-energy-operator', desc: nav.second_product_category_description },
    { name: nav.third_product_category_name, link: '/mortise-locks', desc: nav.third_product_category_description },
    { name: nav.fourth_product_category_name, link: '/cylindrical-locks', desc: nav.fourth_product_category_description },
    { name: nav.fifth_product_category_name, link: '/exit-device-kits', desc: nav.fifth_product_category_description },
    { name: nav.sixth_product_category_name, link: '/exit-devices', desc: nav.sixth_product_category_description },
    { name: nav.seventh_product_category_name, link: '/exit-trims', desc: nav.seventh_product_category_description },
    { name: nav.eight_product_category_name, link: '/power-supplies', desc: nav.eight_product_category_description },
    { name: nav.ninth_product_category_name, link: '/power-transfers', desc: nav.ninth_product_category_description },
    { name: nav.tenth_product_category_name, link: '/accessories', desc: nav.tenth_product_category_description },
  ]

  const resources = [
    { name: nav.first_resource_name, link: '/forms', desc: nav.first_resource_description },
    { name: nav.second_resource_name, link: '/distributors', desc: nav.second_resource_description },
    { name: nav.third_resource_name, link: '/knowledgebase', desc: nav.third_resource_description },
    { name: nav.fourth_resource_name, link: '/sales-representatives', desc: nav.fourth_resource_description },
    { name: nav.fifth_resource_name, link: '/blog', desc: nav.fifth_resource_description },
  ]

  const company = [
    { name: nav.first_menu_name, link: '/about', desc: nav.first_menu_description },
    { name: nav.second_menu_name, link: '/contact', desc: nav.second_menu_description },
  ]

  return (
    <footer className='bg-gray-900 pt-16 pb-16'>
      <div className="w-56 mx-auto mb-12 lg:hidden xl:hidden">
        <Link to="/">
          <UpdateLogoVersion imgData={logo} />
        </Link>

        <div className='w-full mt-6'>
          <div className='w-9/12 mx-auto'>
            <p className={MenuLinkNew}><a href={nav.google_maps_link} target='_blank' rel='noopener noreferrer'>{nav.address}</a></p>
          </div>
          <p className={MenuLinkNew}><a href={`tel:${nav.phone_number}`}>{nav.phone_number}</a></p>
          <p className={MenuLinkNew}><a href={`mailto:${nav.email_address}`}>{nav.email_address}</a></p>
          <p className={MenuLinkNew}>{nav.hours}</p>
        </div>
      </div>

      <div className='relative w-11/12 lg:h-96 xl:max-w-screen-xl mx-auto'>
        <div className='grid grid-cols-1 md:grid-cols-4 gap-3 mx-auto mb-4 pb-8'>
          <div className="w-56 mx-auto hidden lg:block">
            <Link to="/">
              <UpdateLogoVersion imgData={logo} />
            </Link>

            <div className='w-full mt-6'>
              <div className='w-9/12 mx-auto'>
                <p className={MenuLinkNew}><a href={nav.google_maps_link} target='_blank' rel='noopener noreferrer'>{nav.address}</a></p>
              </div>
              <p className={MenuLinkNew}><a href={`tel:${nav.phone_number}`}>{nav.phone_number}</a></p>
              <p className={MenuLinkNew}><a href={`mailto:${nav.email_address}`}>{nav.email_address}</a></p>
              <p className={MenuLinkNew}>{nav.hours}</p>
            </div>
          </div>

          <div className="relative">
            <Menu>
              {({ open }) => (
                <>
                  <Menu.Button className="group inline-flex items-center space-x-1 focus:outline-none">
                    <span className={TitleNew}>Products</span>
                    <svg className="text-white fill-current h-5 w-5 group-hover:text-white group-focus:text-white transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                  </Menu.Button>

                  {/* Use the Transition + open render prop argument to add transitions. */}
                  <Transition
                    show={open}
                    enter="transition ease-out duration-200"
                    enterFrom="transform opacity-0 translate-y-1"
                    enterTo="transform opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="transform opacity-100 translate-y-0"
                    leaveTo="transform opacity-0 translate-y-1"
                  >
                    <Menu.Items static className="absolute -ml-4 mt-2 transform focus:outline-none w-screen max-w-2xl z-50">
                    <div className="rounded-lg shadow-lg">
                      <div className="rounded-lg shadow-xs overflow-hidden">
                        <div className="z-20 relative grid grid-cols-2 gap-8 bg-white p-4">
                          {products.map((product, index) => {
                            return (
                              <Link
                                to={product.link}
                                key={index}
                                className="-m-3 p-3 flex items-start space-x-4 rounded-lg hover:bg-gray-200 transition ease-in-out duration-150"
                              >
                                <Menu.Item className="space-y-1">
                                  <div className='flex flex-col'>
                                    <p className="text-base leading-6 font-bold text-red-900">
                                      {product.name}
                                    </p>
                                    <p className="text-sm leading-5 text-gray-500">
                                      {product.desc}
                                    </p>
                                  </div>
                                </Menu.Item>
                              </Link>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                    </Menu.Items>
                  </Transition>
                </>
              )}
            </Menu>
          </div>

          <div className="relative">
            <Menu>
              {({ open }) => (
                <>
                  <Menu.Button className="group inline-flex items-center space-x-1 focus:outline-none">
                    <span className={TitleNew}>Resources</span>
                    <svg className="text-white fill-current h-5 w-5 group-hover:text-white group-focus:text-white transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                  </Menu.Button>

                  {/* Use the Transition + open render prop argument to add transitions. */}
                  <Transition
                    show={open}
                    enter="transition ease-out duration-200"
                    enterFrom="transform opacity-0 translate-y-1"
                    enterTo="transform opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="transform opacity-100 translate-y-0"
                    leaveTo="transform opacity-0 translate-y-1"
                  >
                    <Menu.Items static className="absolute -ml-4 mt-2 transform focus:outline-none w-screen max-w-2xl z-50">
                    <div className="rounded-lg shadow-lg">
                      <div className="rounded-lg shadow-xs overflow-hidden">
                        <div className="z-20 relative grid grid-cols-2 gap-8 bg-white p-4">
                          {resources.map((resource, index) => {
                            return (
                              <Link
                                to={resource.link}
                                key={index}
                                className="-m-3 p-3 flex items-start space-x-4 rounded-lg hover:bg-gray-200 transition ease-in-out duration-150"
                              >
                                <Menu.Item className="space-y-1">
                                  <div className='flex flex-col'>
                                    <p className="text-base leading-6 font-bold text-red-900">
                                      {resource.name}
                                    </p>
                                    <p className="text-sm leading-5 text-gray-500">
                                      {resource.desc}
                                    </p>
                                  </div>
                                </Menu.Item>
                              </Link>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                    </Menu.Items>
                  </Transition>
                </>
              )}
            </Menu>
          </div>

          <div className="relative">
            <Menu>
              {({ open }) => (
                <>
                  <Menu.Button className="group inline-flex items-center space-x-1 focus:outline-none">
                    <span className={TitleNew}>Company</span>
                    <svg className="text-white fill-current h-5 w-5 group-hover:text-white group-focus:text-white transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                  </Menu.Button>

                  {/* Use the Transition + open render prop argument to add transitions. */}
                  <Transition
                    show={open}
                    enter="transition ease-out duration-200"
                    enterFrom="transform opacity-0 translate-y-1"
                    enterTo="transform opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="transform opacity-100 translate-y-0"
                    leaveTo="transform opacity-0 translate-y-1"
                  >
                    <Menu.Items static className="absolute -ml-4 mt-2 transform focus:outline-none w-screen max-w-xs z-50">
                    <div className="rounded-lg shadow-lg">
                      <div className="rounded-lg shadow-xs overflow-hidden">
                        <div className="z-20 relative grid gap-8 bg-white p-4">
                          {company.map((partner, index) => {
                            return (
                              <Link
                                to={partner.link}
                                key={index}
                                className="-m-3 p-3 flex items-start space-x-4 rounded-lg hover:bg-gray-200 transition ease-in-out duration-150"
                              >
                                <Menu.Item className="space-y-1">
                                  <div className='flex flex-col'>
                                    <p className="text-base leading-6 font-bold text-red-900">
                                      {partner.name}
                                    </p>
                                    <p className="text-sm leading-5 text-gray-500">
                                      {partner.desc}
                                    </p>
                                  </div>
                                </Menu.Item>
                              </Link>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                    </Menu.Items>
                  </Transition>
                </>
              )}
            </Menu>
          </div>
        </div>

        <AddEventWidgetsNew />
      </div>

      <div className='w-11/12 xl:max-w-screen-xl flex flex-col md:flex-row md:items-start mx-auto pt-4 border-t mt-6'>
        <div className='flex items-center w-full md:w-1/3 sm:mb-6'>
          <div className='w-4 mr-8'><a href={nav.twitter_link} target='_blank' rel='noopener noreferrer'><TwitterIcon /><span className='hidden'>Twitter</span></a></div>

          <div className='w-4 mr-8'><a href={nav.linkedin_link} target='_blank' rel='noopener noreferrer'><LinkedinIcon /><span className='hidden'>LinkedIn</span></a></div>

          <div className='w-6'><a href={nav.youtube_link} target='_blank' rel='noopener noreferrer'><YoutubeIcon /><span className='hidden'>Youtube</span></a></div>
        </div>

        <div className='w-full flex flex-col md:flex-row lg:items-center items-start justify-end'>
          <div className='flex my-6 md:my-0'>
            <Link to='/accessibility'>
              <p className='text-xs text-gray-100 hover:underline mr-6'>Accessibility</p>
            </Link>
          </div>

          <div className='flex mb-6 md:my-0'>
            <Link to='/privacy'>
              <p className='text-xs text-gray-100 hover:underline mr-6'>Privacy Policy</p>
            </Link>
          </div>

          <div className='flex mb-6 md:my-0'>
            <Link to='/cookies'>
              <p className='text-xs text-gray-100 hover:underline mr-6'>Cookies Policy</p>
            </Link>
          </div>

          <div className='flex mb-6 md:my-0'>
            <Link to='/do-not-sell'>
              <p className='text-xs text-gray-100 hover:underline mr-6'>Do Not Sell My Personal Information</p>
            </Link>
          </div>

          <p className='font-body text-xs text-blue-200'>© {new Date().getFullYear()} Command Access Technologies.<br className='lg:hidden' /> Website by <a href='https://www.fastweb.dev' target='_blank' rel='noopener noreferrer' className='hover:underline text-white'>fastweb.dev</a></p>
        </div>
      </div>
    </footer>
  )
}

export default FooterNavNewUpdateVersionNew